// apps/web/src/components/notifications/NotificationsManager.tsx
// Notifications center + preferences.

import { ManagerPage } from '../platform/ManagerPage.js';
import type { NotificationItem } from '../../types/platform.js';

export function NotificationsManager() {
  return (
    <ManagerPage
      title="Notifications"
      listPath="/api/v1/notifications"
      listKey="notifications"
      className="notifications-manager"
      renderItem={(raw) => {
        const n = raw as NotificationItem;
        return (
          <div className="manager-card" key={n.id}>
            <h3>{n.title}</h3>
            <p className="status-badge">{n.read ? 'Read' : 'Unread'}</p>
            <p>{n.body ?? ''}</p>
            <p className="muted">{n.type} · {n.createdAt}</p>
            <div className="actions">
              <button className="btn btn-primary">Mark Read</button>
              <button className="btn btn-secondary">Preferences</button>
            </div>
          </div>
        );
      }}
    />
  );
}